// extracted by css-extract-rspack-plugin
export default {"colorWhite":"#fff","avatarContainer":"contact-icon__avatarContainer___BtJ7_","avatar":"contact-icon__avatar___iuslC common__sansSerif___TyY0C common__bold___ve4Qa"};